import React, { useEffect, useRef, useState } from 'react'

import { convertDate } from '../../../assets/ts/date-and-time/date-and-time'
import Accordions from '../../../components/accordions/accordions'
import Buttons from '../../../components/buttons/buttons'
import useReleaseNotes from '../../../hooks/use-release-notes'
import NO_RESULTS from '../../../utils/constants/no-results'
import AddEditView from './add-edit-view'

interface ReleaseNote {
  IsArchived: boolean
  KnownIssues: string
  NewFeatures: string
  ResolvedIssues: string
  eKey?: string
  eTag?: string
  titlename: string
}

const ReleaseNotes = () => {
  const { releaseNotes } = useReleaseNotes({
    orderBy: 'ItemCreated',
  })
  const [releaseNoteItems, setReleaseNoteItems] = useState<ReleaseNote[]>([])
  const popupBodyRef = useRef<HTMLDivElement>(null)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })

  function addEditValue(showAddPopup: any) {
    setShowAddPopup(showAddPopup)
  }

  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowEdit(!showEdit)
  }
  const onEdit = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: item?.Id,
      status: true,
    })
    setShowEdit(true)
  }
  const onAccordion = (item: any) => {
    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }
  function accordionContent(releasenoteslist: any, clickedIndex: any) {
    return (
      <div>
        {inEditMode?.rowKey === releasenoteslist.Id && showEdit ? (
          <AddEditView
            cancel={() => onCancel()}
            clickedIndex={clickedIndex}
            details={releasenoteslist}
            filtersvalue={addEditValue}
            popupBodyRef={popupBodyRef}
            setReleaseNoteItems={setReleaseNoteItems}
            showAddPopup={showAddPopup}
            showEdit={showEdit}
          />
        ) : (
          releasenoteslist?.Id === clickedIndex && (
            <div className='px-3 py-3 releasenoteslist'>
              <div className='border-bottom1 mb-2'>
                <h2 className='color-primary font-13 poppins-semibold'>
                  <span aria-label='Scope' tabIndex={0}>
                    {' '}
                    Scope
                  </span>
                </h2>
              </div>
              <div>
                <ul className='m-0'>
                  <div>
                    {releasenoteslist.NewFeatures.length > 0 && (
                      <div
                        aria-label='New Features'
                        className='title-color20  releasetitle poppins-semibold font-12 p-0'
                        tabIndex={0}
                      >
                        New Features
                      </div>
                    )}
                    <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
                      {releasenoteslist.NewFeatures.length > 0 && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: releasenoteslist.NewFeatures,
                          }}
                        ></span>
                      )}
                    </ul>
                    {releasenoteslist.ResolvedIssues.length > 0 && (
                      <div
                        aria-label='Resolved issues'
                        className='title-color20  releasetitle poppins-semibold font-12 p-0'
                        tabIndex={0}
                      >
                        Resolved issues
                      </div>
                    )}
                    <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
                      {releasenoteslist.ResolvedIssues.length > 0 && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: releasenoteslist.ResolvedIssues,
                          }}
                        ></span>
                      )}
                    </ul>
                    {releasenoteslist.KnownIssues.length > 0 && (
                      <div
                        aria-label='Known Issues'
                        className='title-color20  releasetitle poppins-semibold font-12 p-0'
                        tabIndex={0}
                      >
                        Known Issues
                      </div>
                    )}
                    <ul aria-live='polite' className='list-type-none my-2' tabIndex={0}>
                      {releasenoteslist.KnownIssues.length > 0 && (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: releasenoteslist.KnownIssues,
                          }}
                        ></span>
                      )}
                    </ul>
                  </div>
                </ul>
              </div>
            </div>
          )
        )}
      </div>
    )
  }

  useEffect(() => {
    async function getReleaseNotes() {
      if (releaseNotes.length > 0) {
        const releaseNote =
          releaseNotes?.map((rn, ind) => ({
            Created: ` ${rn.ItemCreatedBy?.properties.defaultDisplay} |  ${convertDate(
              rn.ItemCreated,
              'date'
            )}`,
            Id: ind + 1,
            IsArchived: rn.IsArchived,
            KnownIssues: rn.KnownIssues ? rn.KnownIssues : '',
            Modified: ` ${rn.ItemModifiedBy?.properties.defaultDisplay} |  ${convertDate(
              rn.ItemModified,
              'date'
            )}`,
            NewFeatures: rn.NewFeatures ? rn.NewFeatures : '',
            ResolvedIssues: rn.ResolvedIssues ? rn.ResolvedIssues : '',
            'Version and Date': <span>{rn.VersionName}</span>,
            eKey: rn.eKey,
            eTag: rn.eTag,
            titlename: rn.VersionName,
          })) || []
        setReleaseNoteItems(releaseNote)
      }
    }
    getReleaseNotes()
  }, [releaseNotes])

  // useEffect(() => {
  //   scrollToTop()
  // }, [])

  return (
    <div className='row m-0'>
      <div className='shadow card mt-0 p-2 tabscontent-height'>
        <div className='d-flex align-items-center pt-0 mt-0 p-2'>
          <h2
            aria-label='RELEASE NOTES'
            className='font-16 poppins-semibold title-color2'
            tabIndex={0}
          >
            RELEASE NOTES
          </h2>
          <Buttons
            aria-label='Add'
            className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold '
            icon='icon-add me-xl-1 font-11'
            label='ADD'
            onClick={() => {
              setShowAddPopup(!showAddPopup)
              setShowEdit(false)
              setInEditMode({
                rowKey: null,
                status: false,
              })
            }}
          />
        </div>
        <div className='customaccrdionactive'>
          {showAddPopup && (
            <AddEditView
              cancel={() => onCancel()}
              filtersvalue={addEditValue}
              popupBodyRef={popupBodyRef}
              setReleaseNoteItems={setReleaseNoteItems}
              setShowAddPopup={setShowAddPopup}
              showAddPopup={showAddPopup}
              showEdit={showEdit}
            />
          )}
          {releaseNoteItems.length > 0 ? (
            <Accordions
              ItemId={inEditMode?.rowKey}
              accordionitemclass='shadow card mb-2'
              actionbuttons='settings-actionbtns mx-2 mx-xxl-3'
              actions={[
                {
                  alabel: 'Edit',
                  className:
                    'btn btn-border btn-sm font-0 font-xxl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold',
                  icon: 'icon-pencil me-xxl-1 font-12',
                  label: 'Edit',
                  onClick: onEdit,
                },
              ]}
              className='accordions py-2'
              count='bordered px-1 ms-1 border-radius'
              dataobj={onAccordion}
              defaultActivekey='1'
              dividerClass='dividerdashed vertical mx-2 mx-xxl-3 d-none d-md-block my-1'
              extrasClass='d-flex flex-column flex-md-row flex-nowrap w-100'
              headerextras={[
                {
                  classq: 'me-auto text-break my-2',
                  name: 'Version and Date',
                },
                {
                  classq: 'text-break w-100 min-w-md-200 max-w-md-200 my-2',
                  name: 'Created',
                },
                {
                  classq: 'text-break w-100 min-w-md-200 max-w-md-200 my-2',
                  name: 'Modified',
                },
                {
                  classq: 'text-nowrap w-100 min-w-md-80 max-w-md-80 my-2',
                  name: 'IsArchived',
                },
              ]}
              inputProps={{
                accordionheadClass: 'd-flex align-items-center p-2 custombg',
                className: 'justify-content-start poppins-medium font-13 w-100 p-0',

                contentclassName: 'p-0',
              }}
              isSettings={true}
              items={releaseNoteItems}
              renderHtml={accordionContent}
              titleIcon='icon-minusform font-16 color-primary pe-2'
              titleclassName='title-color35 poppins-semibold font-12'
              titlecollapsedIcon='icon-plusform pe-2 font-16 color-primary'
              titlecontentclassName='poppins-semibold font-12 title-color2 lineClamp2 pe-2'
            />
          ) : (
            <NO_RESULTS />
          )}
        </div>
      </div>
    </div>
  )
}

export default ReleaseNotes
